import axios from 'axios'
import { Toast } from 'vant'
// const baseUrl = 'https://gec-api.gecacademy.cn/souapi'
// const baseUrl = 'http://192.168.0.5:10066/'
// const baseUrl = 'https://gec-api-testserver.gecacademy.cn/souapi'
let baseUrl = ''
const origin = window.location.origin
if (process.env.NODE_ENV === 'development') {
  baseUrl = process.env.VUE_APP_BASE_API
} else {
  if (origin.indexOf('-testserver') > -1) {
    baseUrl = process.env.VUE_APP_BASE_API_DEV
  } else {
    baseUrl = process.env.VUE_APP_BASE_API_MASTER
  }
}
const service = axios.create({ baseURL: baseUrl, timeout: 10000, withCredentials: true })
service.interceptors.request.use(
  config => {
    config.metadata = { startTime: new Date() }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    response.config.metadata.endTime = new Date()
    // const duration = response.config.metadata.endTime - response.config.metadata.startTime
    // Toast({ message: duration, type: 'fail', duration: 5 * 1000 })

    const res = response.data
    return res
  },
  error => {
    Toast({ message: error.message, type: 'fail', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

export default service
